import { render, staticRenderFns } from "./StoragePR_edit.vue?vue&type=template&id=29abb1ff&scoped=true&"
import script from "./StoragePR_edit.vue?vue&type=script&lang=js&"
export * from "./StoragePR_edit.vue?vue&type=script&lang=js&"
import style0 from "./StoragePR_edit.vue?vue&type=style&index=0&id=29abb1ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29abb1ff",
  null
  
)

export default component.exports